/**
 * MyPolyline - JavaScript класс для работы с полилиниями
 * Аналог C# класса MyPolyline
 */
import Vector from "./Vector";
import VectorCollection from "./VectorCollection";

class MyPolyline {
    constructor(points = []) {
        this._points = [...points];
        // console.log(`MyPolyline constructor: создана полилиния с ${this._points.length} точками`);
    }

    get Points() {
        return this._points;
    }

    setPoint(index, point) {
        // console.log(`setPoint: установка точки ${index} в (${point.x}, ${point.y})`);
        if (index >= 0 && index < this._points.length) {
            this._points[index] = point;
            // console.log(`setPoint: точка ${index} установлена`);
        } else {
            // console.log(`setPoint: индекс ${index} вне диапазона [0, ${this._points.length - 1}]`);
        }
    }

    /**
     * Создает срез полилинии от start до end (включительно)
     */
    slice(start, end) {
        if (start < 0 || end < 0 || start >= this._points.length || end > this._points.length || start >= end) {
            return new MyPolyline();
        }
        
        const count = end - start + 1;
        const slicedPoints = [];
        for (let i = 0; i < count; i++) {
            slicedPoints.push(this._points[start + i]);
        }
        
        return new MyPolyline(slicedPoints);
    }

    /**
     * Соединяет две полилинии
     */
    join(line) {
        // console.log(`join: начало, текущая полилиния: ${this._points.length} точек, входящая полилиния: ${line.Points.length} точек`);
        
        if (this._points.length < 2) {
            // console.log('join: недостаточно точек в текущей полилинии, возвращаем входящую');
            return line;
        }
        
        const points2 = line.Points;
        if (points2.length < 2) {
            // console.log('join: недостаточно точек во входящей полилинии, возвращаем текущую');
            return this;
        }
        
        try {
            const vect1 = new Vector(this._points[this._points.length - 2], this._points[this._points.length - 1]);
            const vect2 = new Vector(points2[0], points2[1]);
            
            const cross = vect1.cross(vect2);
            // console.log(`join: пересечение: (${cross.x}, ${cross.y})`);
            
            // Проверяем, что пересечение валидно
            if (!isNaN(cross.x) && !isNaN(cross.y)) {
                const points1 = this._points.slice(0, -1); // Убираем последнюю точку
                points1.push(cross);
                points1.push(...points2.slice(1));
                const result = new MyPolyline(points1);
                // console.log(`join: создана полилиния с пересечением, ${result.Points.length} точек`);
                return result;
            } else {
                // Если пересечение не найдено, просто соединяем
                const points1 = [...this._points];
                points1.push(...points2);
                const result = new MyPolyline(points1);
                // console.log(`join: создана полилиния без пересечения, ${result.Points.length} точек`);
                return result;
            }
        } catch (error) {
            console.error('join: ошибка при вычислении пересечения:', error);
            // Если произошла ошибка, просто соединяем
            const points1 = [...this._points];
            points1.push(...points2);
            const result = new MyPolyline(points1);
            // console.log(`join: создана полилиния после ошибки, ${result.Points.length} точек`);
            return result;
        }
    }

    /**
     * Создает параллельную полилинию
     */
    parallel(offset) {
        // console.log(`=== PARALLEL МЕТОД НАЧАЛО ===`);
        // console.log(`parallel: входные параметры - offset: ${offset}, количество точек: ${this._points.length}`);
        
        if (this._points.length < 2) {
            // console.log('parallel: недостаточно точек для создания полилинии');
            return new MyPolyline();
        }
        /*
        // Выводим первые несколько точек для проверки
        // console.log('parallel: первые 3 точки:');
        for (let i = 0; i < Math.min(3, this._points.length); i++) {
            const point = this._points[i];
            // console.log(`  Точка ${i}: (${point.x}, ${point.y})`);
        }
        */
        try {
           
            // console.log(`parallel: создаем VectorCollection из ${this._points.length} точек`);
            const vc = VectorCollection.fromPoints(this._points);
             /*
             // console.log(`parallel: VectorCollection создан, количество векторов: ${vc.Count}`);
            
            // Проверяем векторы в коллекции
            // console.log('parallel: проверяем векторы в коллекции:');
            for (let i = 0; i < Math.min(3, vc.Count); i++) {
                const vector = vc.get(i);
                // console.log(`  Вектор ${i}: (${vector.StartPoint.x}, ${vector.StartPoint.y}) -> (${vector.EndPoint.x}, ${vector.EndPoint.y})`);
            }
            */
            // console.log(`parallel: вызываем offset(${offset})`);
            const offsetCollection = vc.offset(offset);
            // console.log(`parallel: offsetCollection получен:`, offsetCollection);
            // console.log(`parallel: тип offsetCollection:`, typeof offsetCollection);
            // console.log(`parallel: offsetCollection null?`, offsetCollection === null);
            // console.log(`parallel: offsetCollection undefined?`, offsetCollection === undefined);
            
            // Проверяем, что offsetCollection не null и имеет метод getPoints
            if (offsetCollection && typeof offsetCollection.getPoints === 'function') {
                // console.log('parallel: вызываем getPoints()');
                const offsetPoints = offsetCollection.getPoints();
                // console.log(`parallel: получено ${offsetPoints ? offsetPoints.length : 'null'} точек`);
                // console.log(`parallel: тип offsetPoints:`, typeof offsetPoints);
                // console.log(`parallel: offsetPoints null?`, offsetPoints === null);
                // console.log(`parallel: offsetPoints undefined?`, offsetPoints === undefined);
                
                if (offsetPoints && offsetPoints.length > 0) {
                    // console.log('parallel: создаем новую полилинию из полученных точек');
                    const result = new MyPolyline(offsetPoints);
                    // console.log(`parallel: создана полилиния с ${result.Points.length} точками`);
                    // console.log(`=== PARALLEL МЕТОД УСПЕХ ===`);
                    return result;
                } else {
                    // console.log('parallel: offsetPoints пустые или null');
                }
            } else {
                // console.log('parallel: offsetCollection не имеет метода getPoints или null');
                if (offsetCollection) {
                    // console.log('parallel: доступные методы offsetCollection:', Object.getOwnPropertyNames(offsetCollection));
                }
            }
            
            // Если что-то пошло не так, возвращаем пустую полилинию
            // console.log('parallel: возвращаем пустую полилинию');
            // console.log(`=== PARALLEL МЕТОД ПРОВАЛ ===`);
            return new MyPolyline();
        } catch (error) {
            console.error('Ошибка в методе parallel:', error);
            // console.log(`=== PARALLEL МЕТОД ОШИБКА ===`);
            return new MyPolyline();
        }
    }

    /**
     * Создает параллельную полилинию для ближайших сегментов
     * 1. Склеить все полилинии в одну
     * 1.1 Сразу записываю смещения в массиве на границах полилиний см(getNearest)
     */
    parallelNearest(offset) {
        const nearest = this.getNearest(offset).sort((a, b) => a[0] - b[0]);
        if (nearest.length === 0) return this;

        let lastPoint = 0;
        let result = new MyPolyline();
        
        for (const vec of nearest) {
            if (vec[0] !== lastPoint) {
                result = result.join(this.slice(lastPoint, vec[0]));
            }
            result = result.join(this.slice(vec[0], vec[1]).parallel(offset));
            lastPoint = vec[1];
        }
        
        // Добавляем оставшуюся часть
        if (lastPoint < this._points.length) {
            result = result.join(this.slice(lastPoint, this._points.length - 1));
        }
        
        return result;
    }

    /**
     * Создает обратную полилинию (точки в обратном порядке)
     */
    reverse() {
        // console.log(`reverse: начало, количество точек: ${this._points.length}`);
        
        if (this._points.length < 2) {
            // console.log('reverse: недостаточно точек, возвращаем копию');
            return new MyPolyline(this._points);
        }
        
        const reversedPoints = [...this._points].reverse();
        // console.log(`reverse: создана обратная полилиния с ${reversedPoints.length} точками`);
        
        const result = new MyPolyline(reversedPoints);
        // console.log(`reverse: возвращаем полилинию с ${result.Points.length} точками`);
        return result;
    }

    /**
     * Получает ближайшие точки
     */
    getNearest(diff) {
        const result = [];
        let start = -1;
        let end = -1;
        let start1 = -1;
        let end1 = -1;
        
        for (let i = 0; i < this._points.length; ++i) {
            if (start === -1) {
                const n = this.getNearestPoint(i, diff);
                if (n === null) continue;
                start = i;
                end = i;
                start1 = n;
                end1 = n;
                continue;
            }

            if (this._points[i].dist(this._points[start1 - 1]) < diff) {
                end = i;
                start1--;
                continue;
            }
            
            // совпадения закончились. Проверяем, что сформированы отрезки.
            if (start !== end) {
                result.push([start, end]);
                result.push([start1, end1]);
            }
            start = -1;
            end = -1;
            start1 = -1;
            end1 = -1;
        }

        if (start === end) return result;
        result.push([start, end]);
        result.push([start1, end1]);
        return result;
    }
    
    /**
     * Получает ближайшую точку
     */
    getNearestPoint(pntPtr, diff) {
        const p = this._points[pntPtr];
        for (let i = 0; i < pntPtr; ++i) {
            const dist = p.dist(this._points[i]);
            if (dist < diff) return i;
        }
        return null;
    }

    /**
     * Генерирует случайные точки для полилинии
     */
    static generateRandomPoints(count = 30) {
        const centerX = 400.0;
        const centerY = 300.0;
        const baseRadius = 150.0;
        const points = [];

        // Генерируем точки неправильного многоугольника
        for (let i = 0; i < count; i++) {
            const angle = i * 2 * Math.PI / count;
            const radiusVariation = (Math.random() - 0.5) * 100; // ±50 пикселей
            const radius = baseRadius + radiusVariation;

            const x = centerX + radius * Math.cos(angle);
            const y = centerY + radius * Math.sin(angle);

            points.push(new MyPoint(x, y));
        }

        // Создаем разомкнутый полигон - удаляем последний сегмент
        const result = points.slice(0, -1);
        // console.log(`generateRandomPoints: создано ${result.length} точек`);
        return result;
    }
}

export default MyPolyline;